import { FormRequest } from './form-request';

/**
 * Coordinates the phase-based workflow used by reactive form containers.
 *
 * This class intentionally has no Angular decorator. It replaces the old
 * pattern of instantiating `ReactiveFormBuilderComponent` only to access
 * `addEvent()` and `executePhase()`. Parent form components can safely own one
 * instance of this coordinator without coupling themselves to a visual Angular
 * component.
 */
export class ReactiveFormRequestCoordinator<T = unknown> extends FormRequest {
    /**
     * Optional contextual model type marker. It keeps the coordinator generic for
     * callers without affecting runtime behaviour.
     */
    public readonly modelType?: T;
}
